class Menu {
    constructor() {
        this.lastScrollTopBeforeOpenMenu = 0;
        this.evt = 'touchstart';
        if (navigator.msPointerEnabled || !('ontouchend' in window)) this.evt = "click";

        jQuery('#hamburger').on(this.evt,function(e) {
            if (jQuery('html').hasClass('hamburger-eaten')){
                this.close();
            }else{
                this.open();
            }
        }.bind(this));


        /* RESPONSIVE */
        jQuery('#block-panelux-main-menu > ul > li:has(ul), .sidebar nav > ul > li:has(ul)').addClass('submenu');

        jQuery('#block-panelux-main-menu > ul > li.submenu > a, .sidebar nav > ul > li.submenu > a').click(function () {

            var has = jQuery(this).parent().hasClass('submenu-open');
            jQuery('#block-panelux-main-menu > ul > li > a, .sidebar nav > ul > li > a').parent().removeClass('submenu-open');

            if (has){
                jQuery(this).parent().removeClass('submenu-open');
            }else{
                jQuery(this).parent().addClass('submenu-open');
            }

            return false;
        });

        jQuery('.sidebar nav > ul > li.submenu').each(function() {
            if(jQuery(this).hasClass('is-active')) {
                jQuery(this).addClass('submenu-open');
            }
        });

    }


    open(){
        this.lastScrollTopBeforeOpenMenu = jQuery(window).scrollTop();
        jQuery('html').addClass('hamburger-eaten');
    }

    close(){
        jQuery('html').addClass('hamburger-renew');
        jQuery('html').removeClass('hamburger-eaten');

        jQuery(window).scrollTop(this.lastScrollTopBeforeOpenMenu);

        setTimeout(function(){
            jQuery('html').removeClass('hamburger-renew');
        },1000);
    }


}